import { useCallback, useState } from 'react'
import TextArea from '../../../../../../../../forms/Input/TextArea'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../../../../../../../baseComponents/Modal'
import { ModalOpenedSetTy } from '../../../../../../../../baseComponents/Modal/types'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types'

interface ModalEditableTextProductOrderProps extends ModalEditableTextProductOrderLogicProps {}

const ModalEditableTextProductOrder: React.FC<ModalEditableTextProductOrderProps> = ({setOpened, allRowData, ...rest}) => {
    const { textAreaValue, setTextAreaValue, updateValue } = useModalEditableTextProductOrderLogic({ setOpened, allRowData, ...rest })
    const {t} = useTwinTranslation()
    return (
        <ModalSmallCentered opened={true} setOpened={setOpened} className='big_small_centered'>
            <div>
                <h2><TwinTrans transKey='edit'>Editar</TwinTrans> {allRowData.label}</h2>
                <TextArea className='mt-10' label={allRowData.label} placeholder={t('write', 'Escribe...')} hideLabel={true} onChange={setTextAreaValue} value={textAreaValue} />
            </div>
            <ButtonsModalSmallCentered confirmText={t('accept', 'Aceptar')} setOpened={setOpened} onAccept={updateValue} />
        </ModalSmallCentered>
    )
}

interface ModalEditableTextProductOrderLogicProps {
    allRowData: RowData
    onSubmit: (value: string) => void
    setOpened: ModalOpenedSetTy
}

const useModalEditableTextProductOrderLogic = ({setOpened, onSubmit, allRowData}: ModalEditableTextProductOrderLogicProps) => {
    const [textAreaValue, setTextAreaValue] = useState(allRowData.value || '')
    const updateValue = useCallback(() => {
        onSubmit(textAreaValue)
        setOpened(null)
    }, [textAreaValue, onSubmit, setOpened])
    return {updateValue, setTextAreaValue, textAreaValue}
}

export default ModalEditableTextProductOrder